import { Paper } from '@material-ui/core';
import React, { FC, memo } from 'react';
import { colorDef } from '../../../constants/styles/color-def';

interface Props {
  children: React.ReactNode;
  elevation?: number;
  square?: boolean;
  bgColor?: string;
}

export const MuiPaper: FC<Props> = memo(
  ({
    children,
    elevation = 0,
    square = false,
    bgColor = colorDef.paper
  }: Readonly<Props>) => (
    <Paper
      style={{ backgroundColor: bgColor }}
      elevation={elevation}
      square={square}
    >
      {children}
    </Paper>
  )
);

MuiPaper.displayName = 'MuiPaper';
